<template>
  <div class="content">
    <system :leftList="leftList"></system>
    <div class="pageBox">
      <div class="breadcrumb">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>角色管理</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="pageSerch">
        <el-card class="box-card" shadow="never">
          <div slot="header" class="clearfix">
            <span class="cardTitle">角色列表</span>
          </div>
          <el-form ref="ruleForm" :model="ruleForm">
            <el-row :gutter="20">
              <el-col :span="6">
                <el-form-item label="角色名称">
                  <el-input
                    maxlength="50"
                    clearable
                    v-model="ruleForm.name"
                    placeholder="请输入角色名称"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item>
                  <el-button type="primary" @click="getList()" class="btn"
                    >查询</el-button
                  >
                  <el-button @click="resetForm()">重置</el-button>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </el-card>
      </div>
      <div class="pageTab">
        <el-button
          type="primary"
          class="btn"
          style="margin-bottom: 16px"
          @click="add()"
          >添加</el-button
        >
        <el-table ref="scrollTable" :data="tableData" style="width: 100%">
          <el-table-column prop="id" label="编号" align="center">
          </el-table-column>
          <el-table-column prop="name" label="角色名称" align="center">
          </el-table-column>
          <el-table-column prop="roleDesc" label="角色描述" align="center">
          </el-table-column>
          <el-table-column prop="creatorName" label="创建人" align="center">
          </el-table-column>
          <el-table-column label="操作" align="center">
            <template slot-scope="scope">
              <div class="disAround">
                <div class="operateBtn redColor1" @click="Delete(scope.row)">
                  删除
                </div>
                <div class="operateBtn" @click="handleEdit(scope.row)">
                  编辑
                </div>
                <div class="operateBtn" @click="ruleEdit(scope.row)">
                  权限设置
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-sizes="[10, 20, 30, 50]"
          :page-size="pageSize"
          layout="total, prev, pager, next,sizes"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
    <el-drawer title="我是标题" :visible.sync="drawer" :with-header="false">
      <div class="list">
        <el-tree
          :data="data"
          ref="menuRef"
          show-checkbox
          node-key="id"
          default-expand-all
          :default-checked-keys="selectArr"
          :props="defaultProps"
          :check-strictly="true"
        >
        </el-tree>
      </div>
      <div
        style="
          text-align: center;
          display: flex;
          align-items: center;
          justify-content: center;
        "
      >
        <el-button style="margin-top: 30px" @click="drawer = false"
          >取消</el-button
        >
        <el-button
          type="primary"
          class="btn"
          style="margin-top: 30px"
          @click="save()"
          >保存</el-button
        >
      </div>
    </el-drawer>
  </div>
</template>

<script>
import system from "../../components/system_left.vue";
export default {
  components: {
    system,
  },
  data() {
    return {
      leftList: this.Plugins.systemData(),
      ruleForm: {
        name: "",
      },
      tableData: [],
      page: 1,
      pageSize: 10,
      total: 0,
      drawer: false,
      data: [],
      defaultProps: {
        children: "children",
        label: "name",
      },
      selectId: "",
      selectArr: [],
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    ruleEdit(val) {
      this.selectId = val.id;
      this.getRuleList();
    },
    save() {
      let arr = this.$refs.menuRef.getCheckedKeys();
      let arr1 = this.$refs.menuRef.getHalfCheckedNodes();
      for (var i = 0; i < arr1.length; i++) {
        arr.push(arr1[i].id);
      }
      let param = {
        menuIds: arr,
        sysRoleId: this.selectId,
      };
      this.$axios
        .post(`/admapi/sys/roles/grant-menus/${this.selectId}`, param)
        .then(({ data }) => {
          this.$message({
            message: "编辑成功",
            type: "success",
          });
          this.drawer = false;
        })
        .catch()
        .finally();
    },
    getRuleList(val) {
      this.$axios
        .post(`/admapi/sys/roles/list-menus/${this.selectId}`)
        .then(({ data }) => {
          this.data = data;
          this.drawer = true;
          let arr1 = data;
          // const flatten1 = arr1 =>
          //   arr1.reduce(
          //     (acc, val) =>
          //       acc.concat(
          //         Array.isArray(val.children) ? flatten1(val.children) : val
          //       ),
          //     []
          //   );
          let list = this.flattenReduceFlatMap(arr1);
          let selectData = [];
          console.log(list);
          for (var i = 0; i < list.length; i++) {
            if (list[i].checked == 1) {
              selectData.push(list[i].id);
            }
          }
          this.selectArr = selectData;
        })
        .catch()
        .finally();
    },
    flattenReduceFlatMap(arr) {
      return arr.reduce((acc, val) => {
        return acc.concat(
          val,
          ...(Array.isArray(val.children)
            ? this.flattenReduceFlatMap(val.children)
            : [])
        );
      }, []);
    },
    fun(arr) {
      let newArr = [];
      for (var i = 0; i < arr.length; i++) {
        if (Array.isArray(arr[i].children)) {
          fun(arr[i].children);
        } else {
          newArr.push(arr[i].children);
        }
      }
      console.log(newArr);
    },
    resetForm() {
      this.ruleForm.name = "";
      this.getList();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getList();
    },
    add() {
      this.$router.push("/ruleAdd");
    },
    handleEdit(val) {
      this.$router.push({
        path: "/ruleAdd",
        query: {
          id: val.id,
        },
      });
    },
    getList() {
      let param = {
        page: this.page,
        pageSize: this.pageSize,
        queryParams: [
          { name: "name", type: "input", value: this.ruleForm.name },
        ],
      };
      this.$axios
        .post(`/admapi/sys/roles/list`, param)
        .then(({ data }) => {
          this.tableData = data.items;
          this.total = data.page.totalRows;
        })
        .catch()
        .finally();
    },
    Delete(val) {
      this.$confirm("是否删除", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$axios
            .post(`/admapi/sys/roles/delete/${val.id}`)
            .then(({ data }) => {
              this.$message({
                message: "删除成功",
                type: "success",
              });
              this.getList();
            })
            .catch()
            .finally();
        })
        .catch(() => {});
    },
  },
};
</script>
<style scoped>
.list {
  height: 90vh;
  overflow-y: scroll;
}
/* /deep/ .el-drawer__body {
  overflow: hidden;
} */
</style>
